import { BATTLE_RULE_SET_ID } from '../rules/battleRuleSet';
import { BALANCE } from '../balance';
import { GAME_MODE, type GameModeId } from '../types';
import { BaseGameMode } from './BaseGameMode';
import type { GameModeDefinition } from './GameMode';

/**
 * Two seats, one match.
 *
 * Both independent boards and their cross-seat damage live in battleRuleSet.
 * The mode remains intentionally thin: it defines the number of seats and the
 * match identity while the pure rules stay reusable for client prediction.
 */
export class VersusMode extends BaseGameMode {
  override readonly id: GameModeId = GAME_MODE.VERSUS;
  override readonly requiredSeats: number = 2;
  override readonly roundDurationMs: number | null = BALANCE.phases.versusRoundMs;
}

export const versusModeDefinition: GameModeDefinition = {
  id: GAME_MODE.VERSUS,
  requiredSeats: 2,
  defaultRuleSetId: BATTLE_RULE_SET_ID,
  create: (ruleSetId = BATTLE_RULE_SET_ID) => new VersusMode(ruleSetId),
};
